<template>
    <v-container fluid class="text-block">
        <h1 class="underline">Liebe Margit</h1>
        <p class="subtitle">Gedanken</p>
        <div>
            <p>Es gibt mittlerweile schon ein paar Anlässe zur Gratulation und um sich zu bedanken: Hochzeitstag, Jahrestag, Monatstag, Valentinstag, Muttertag, Silvester, etc. Und dann gibt es natürlich noch den Geburtstag. Diesmal sogar ein Runder. All diese besonderen Tage sind bezeichnend dafür, wie viel du schon erlebt und erreicht hast. Ich möchte dir diesbezüglich gratulieren und danken.</p>
            <p class="underline mb-1">Gratulieren.</p>
            <p>
                Gratulieren zu deinen Kindern. Deinen wundervollen, hübschen, herrlich ehrlichen und wohlerzogenen Kindern. Deiner Arbeit, wofür du so viel gibst und auch so viel zurück bekommst. Deinen stetem treiben nach Zufriedenheit, denn das ist was zählt. Wir sind alle am Weg, aber gratuliere zu der Strecke die du schon zurück gelegt hast.
            </p>
            <p class="underline mb-1">Danken.</p>
            <p>
                Danken ein Teil von deinem Leben zu sein. Danken für die schönen und schwierigen Momente die mein Leben reicher machen und mich persönlich wachsen lassen. Es gibt viele große Aufmerksamkeiten aber vor allem die wunderbaren Kleinigkeiten die mir das Gefühl geben am richtigen Platz zur richtigen Zeit zu sein. An deiner Seite. Dafür möchte ich dir danken. Ich will dir danken für jedes “Ich liebe dich” vor dem Schlafengehen, jeden kleinen und großen Zettel den ich auf unserem Esstisch finde und die mich so sehr begeistern.
            </p>
            <p>
                Ich wünsche dir, mir, uns und vor allem unserer kleinen Familie als ganzes viele weitere bereichernde Momente.
            </p>
            <p class="text-center">Alles gute zum Geburtstag.</p>
            <p class="text-center">○○●●○○●●  ○○●●○○○○  ○●●○○●○●  ○●●●○○●○</p>
        </div>
    </v-container>
</template>

<script>
    import '../assets/main.css';
    export default {
        name: "Thoughts"
    }
</script>

<style scoped>

</style>
